
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(9(040|654|773)|7(308|373|421)|8(299|336|69|898)|129|2071|3826|4386|495)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
